// Module
var code = "<p>To run the \\n Marine Conditions service, \\n go through the following steps:</p> ";
// Exports
module.exports = code;